module.exports = __webpack_public_path__ + "static/media/logo.be39f5e3.svg";